export const ITMenuList = [
    {
        title: "Audit Trial",
        iconStyle: imagepaths.reportsIcon,
        iconActive: imagepaths.reportsIconActive,
        to: "/app/audittrail",
        id: "audittrail",
    },
]